export function middleEllipsis(text: string, container: HTMLElement, padding = 10): string {
  const containerWidth: number = container.offsetWidth - padding;
  const canvas: HTMLCanvasElement = document.createElement('canvas');
  const context: CanvasRenderingContext2D = canvas.getContext('2d');

  // Match container font
  const style: CSSStyleDeclaration = window.getComputedStyle(container);
  context.font = `${style.fontSize} ${style.fontFamily}`;

  if (context.measureText(text).width <= containerWidth) {
    container.textContent = text;
    return;
  }

  let left: number = 0;
  let right: number = text.length;
  let midText: string = text;

  // Binary search the max characters that can fit
  while (left < right) {
    const mid: number = Math.floor((left + right) / 2);
    const start: string = text.slice(0, Math.ceil(mid / 2));
    const end: string = text.slice(-Math.floor(mid / 2));
    const testText = `${start}…${end}`;
    const testWidth: number = context.measureText(testText).width;

    if (testWidth <= containerWidth) {
      midText = testText;
      left = mid + 1;
    } else {
      right = mid;
    }
  }

  return midText;
}
